import React, { PureComponent } from 'react';
import styled from 'styled-components';

import CustomerPreferencesData from "../../../data/onboarding/customer-preferences.json";

import CustomerPreferencesImage from '../../../containers/assets/onboarding-customer-preferences.png';

const Wrapper = styled.div`
  background: #f5f6f7;
  flex: 1;
`;

const Container = styled.div`
  padding: 40px;
  width: 80%;
  max-width: 794px;
`;

const Text1 = styled.div`
  font-family: 'Mukta Vaani';
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 16px;
  color: rgba(0, 27, 59, 0.38);
  text-transform: uppercase;
`;

const Text2 = styled.div`
  font-family: 'Mukta Vaani';
  font-style: normal;
  font-weight: 700;
  font-size: 21px;
  line-height: 28px;
  color: rgba(0, 27, 59, 0.94);
  margin-top: 24px;
`;

const Text3 = styled.div`
  font-family: 'Mukta Vaani';
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 24px;
  color: rgba(0, 27, 59, 0.6);
  margin-top: 12px;

  b {
    color: #2da548;
  }

  strong {
    color: #ec5e59;
  }
`;

const Image = styled.div`
  display: flex;
  margin-top: 12px;
`;

class CustomerPreferences extends PureComponent {

  constructor(props) {
    super(props);

    this.state = {}
  }

  componentDidMount() {
    this.props.setMode('basic');
  }

  render() {
    const { roundInUrl } = this.props;

    return (
      <Wrapper>
        <Container>
          <Text1>{CustomerPreferencesData.rounds[roundInUrl - 1].text1}</Text1>
          <Text2>{CustomerPreferencesData.rounds[roundInUrl - 1].text2}</Text2>
          <Text3 dangerouslySetInnerHTML={{ __html: CustomerPreferencesData.rounds[roundInUrl - 1].text3 }} />

          <Image>
            <img src={CustomerPreferencesImage} alt="" />
          </Image>
        </Container>
      </Wrapper>
    );
  }

}

export default CustomerPreferences;



// WEBPACK FOOTER //
// ./src/components/onboarding/what-to-expect/CustomerPreferences.js